import { REDUX_ACTIONS } from 'utils/constants';
import { isNumber } from 'utils/common';
import { ChampionBranding, MessageMedia } from 'utils/gloo-types';

export interface InfoState {
  branding?: ChampionBranding;
  notifications?: {
    prayerRequestCount: number;
    unresolvedCount: number;
    newExplorerConnectionsCount: number | null;
    totalExplorerConnectionsCount: number | null;
    orgActiveUsers: number;
    orgPlanLimit: number | null;
    messages: {
      usedCredits: number | null;
      totalCredits: number | null;
      rolloverCredits: number | null;
    };
    hasFavorites: boolean;
  };
  draftMessages: { [key: string]: { message: string; messageMedia: MessageMedia[] } };
}

const defaultNotifications: InfoState['notifications'] = {
  prayerRequestCount: 0,
  unresolvedCount: 0,
  newExplorerConnectionsCount: null,
  totalExplorerConnectionsCount: null,
  orgActiveUsers: 0,
  orgPlanLimit: null,
  messages: {
    usedCredits: null,
    totalCredits: null,
    rolloverCredits: null,
  },
  hasFavorites: false,
};

export const initialState: InfoState = {
  branding: {},
  notifications: defaultNotifications,
  draftMessages: {},
};

export default function infoReducer(state = initialState, action: any): InfoState {
  switch (action.type) {
    case REDUX_ACTIONS.SET_BRANDING:
      return { ...state, branding: action.branding };
    case REDUX_ACTIONS.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: {
          ...((state.notifications || {}) as InfoState['notifications']),
          ...{
            prayerRequestCount: isNumber(action.prayerRequestCount) ? action.prayerRequestCount : 0,
            unresolvedCount: isNumber(action.unresolvedCount) ? action.unresolvedCount : 0,
            orgActiveUsers: isNumber(action.orgActiveUsers) ? action.orgActiveUsers : 0,
            newExplorerConnectionsCount: isNumber(action.newExplorerConnectionsCount)
              ? action.newExplorerConnectionsCount
              : null,
            totalExplorerConnectionsCount: isNumber(action.totalExplorerConnectionsCount)
              ? action.totalExplorerConnectionsCount
              : null,
          },
          ...(isNumber(action.orgPlanLimit) || action.orgPlanLimit === null
            ? { orgPlanLimit: action.orgPlanLimit }
            : {}),
          ...(isNumber(action.broadcastLimit) || action.broadcastLimit === null
            ? { broadcastLimit: action.broadcastLimit }
            : {}),
          messages: {
            rolloverCredits: action.msgRolloverCredits,
            totalCredits: action.msgTotalCredits,
            usedCredits: action.msgUsage,
          },
          hasFavorites: action.hasFavorites,
        },
      };
    case REDUX_ACTIONS.SET_NOTIFICATION_COUNT:
      return {
        ...state,
        notifications: { ...((state.notifications || {}) as InfoState['notifications']), [action.key]: action.count },
      };
    case REDUX_ACTIONS.CHANGE_ORG:
      return { ...state, notifications: defaultNotifications };
    case REDUX_ACTIONS.UPDATE_KIT_OR_HUB_IN_PROGRESS:
      return {
        ...state,
        notifications: {
          ...((state.notifications || {}) as InfoState['notifications']),
          hasFavorites: action.hasFavorites,
        },
      };
    case REDUX_ACTIONS.UPDATE_DRAFT_MESSAGE:
      return {
        ...state,
        draftMessages: { ...state.draftMessages, [action.key]: action.value },
      };

    case REDUX_ACTIONS.DELETE_DRAFT_MESSAGE: {
      const newState: any = { ...state };
      delete newState.draftMessages[action.key];
      return newState;
    }

    case REDUX_ACTIONS.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
